import Controller from '../abstracts/Controller';

export default class StoreLocatorDetailController extends Controller {

  static get COMPONENTS() {
    return ["StoreLocatorDetailComponent", "PrintComponent", "BookingAptComponent", 'VideoComponent',];
  }


  init() {
    super.init();
  }

}
